import "./index.scss";
import GadgetsLogo from "../../assets/logo/gadget 360 logo.png";
import CompanyLogoAA from "../../assets/logo/AcrossLogo.png";

const Topbar = () => {
  return (
    <nav className="topbar">
      <div className="topbar__logo">
        <a href="https://www.gadgets360shield.com/products">
          <img src={GadgetsLogo} alt="Gadgets360" />
        </a>
      </div>
      <div className="topbar__powered">
        <span className="topbar__powered-label">Powered by</span>
        <div className="topbar__powered-badge">
          <img src={CompanyLogoAA} alt="Across Assist" />
        </div>
      </div>
    </nav>
  );
};

export default Topbar;
